import { createAction } from '@reduxjs/toolkit';
import GoogleAnalytics from 'api/google_analytics';

export const submitAction = createAction('google_analytics/submit');

export const submitToGoogleAnalytics =
  ({ payment_type_id }) =>
  (dispatch, getState) => {
    const booking = getState().booking.current;
    const { client_type_name = null } = getState().user || {};
    const { productTypes } = getState().types;

    // Mangle booking object
    const country = getState().countries[booking.country_id].name;

    const fillReservationCategory = (reservation) => {
      const productType = productTypes[reservation.product_type_id];

      return { ...reservation, category: productType?.name };
    };

    const annotatedBooking = {
      ...booking,
      country,
      reservations_attributes: booking.reservations_attributes?.map(
        fillReservationCategory
      ),
      payment_type_id,
      client_type_name,
    };

    dispatch(submitAction(annotatedBooking));
    GoogleAnalytics.sendBookingData(annotatedBooking);
  };
